import React from 'react'
import Header from '../../Token/Components/Header'

import { Container, Grid } from '@mui/material'
import { P, SectionHeading } from '../../../Styles/style'


import { useTheme } from '@emotion/react'

import aboutimg from "../../../../assets/images/aboutimg.png"
import arrow from "../../../../assets/images/whitearrow.png"
import styled from '@emotion/styled'
const SectionWrapper = styled.div`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
place-content: center;
flex-direction: column;
align-items: center;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    /* padding: ${(props) => (props.p799 ? props.p799 : "30px 0")}; */
  }
  @media screen and (max-width: 599px) {
    /* padding: ${(props) => (props.p599 ? props.p599 : "30px 0")}; */
  }
`;
const ConnectButt = styled.a`
background-color: ${(props) => (props.bgcolor ? props.bgcolor : "")};
display: flex;
align-items: center;
text-align: center;
place-content: center;
margin: ${(props) => (props.m ? props.m : "")};
padding: ${(props) => (props.p ? props.p : "11px 30px")};
font-family: "Poppins-Medium";
font-size: 15px;
color: ${(props) => props.theme.textSecondary};
text-decoration:none ;
cursor: pointer;
border: 1px solid ${(props) => (props.border ? props.border : props.theme.textSecondary)};
@media screen and (max-width:599px){
  /* padding: ${(props) => (props.p ? props.p : "7px 10px")}; */
  /* max-width: ${(props) => (props.mw ? props.mw : "50%")}; */

}
`
const BtnDIv = styled.div`
display: flex;
align-items:center ;
gap: 23px;
padding: 40px 0;
@media screen and (max-width:699px){

  display: inline-grid;
}
`
const MainGrid = styled(Grid)`
padding: 80px 0 30px;
justify-content: center;
text-align: LEFT;
`
const GridImg = styled(Grid)`
text-align-last: right;
`
const GridText = styled(Grid)`
/* padding: 80px 0 0; */
`
const LearnBuutt = styled.a`
    border: 1px solid  ${(props) => props.theme.textPrimary} ;
color: ${(props) => props.theme.textPrimary} ;
padding: 7px 20px;
text-decoration: none;
`
const MetAMskimg = styled.img`
   width:100%;
   max-width: 500px;
`
const S1_About = () => {
  return (
    <div>
      <Header heading="About Us" para="Security And Privacy For Everyone." />
      <Container maxWidth="xl">
        <MainGrid container rowGap={2}>
          <GridText item xs={12} md={5} >
            <SectionHeading data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000">
              Vision
            </SectionHeading>

            <P data-aos="fade-up"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-offset="0"
              data-aos-duration="1000">Privacy is something all humans instinctually value. It is a well-recognized human right, and even those who deny it to others expect it for themselves.
              <br />
              <br />
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem
            </P>

          </GridText>

          {/* <Grid item xs={2} /> */}
          <GridImg item xs={12} md={5}
            data-aos="zoom-in"
            // data-aos-anchor-placement="top-bottom"
            data-aos-delay="300"
            data-aos-offset="0"
            data-aos-duration="1000">
            <MetAMskimg src={aboutimg} />
          </GridImg>
        </MainGrid>
      </Container>
    </div>
  )
}

export default S1_About